import React from "react";
import styled from "styled-components/macro";

const JunoLink = styled.a`
  font-size: inherit;
  color: var(--juno-color-link);
  cursor: pointer;
  margin-bottom: 0.25em;
  border-bottom: 1px solid transparent;

  &:hover {
    color: var(--juno-color-link-hover);
    border-bottom-color: var(--juno-color-link-hover);
  }

  &:focus-visible {
    outline: var(--juno-focus-outline-width) solid var(--juno-color-focus);
    outline-offset: var(--juno-focus-outline-offset);
  }
`;

function Link(props) {
  return <JunoLink {...props}>{props.children}</JunoLink>;
}

export default Link;
